import {WebDeskAppStore} from "@/store/WebDeskAppStore";
import {merge} from "lodash-es";

export function getWebDeskUrl(endpoint: string | null = null, query?: Record<string, any>): string {
    // @ts-ignore
    const host = import.meta.env.VITE_NFHOTEL_HOST;
    let url = `//a.${host}/api/${endpoint ?? ''}`;
    if (query)
        url += '?' + new URLSearchParams(query).toString();
    return url;
}

export function getWebDeskRequest(method: string,
                                  body?: Record<string,any>,
): RequestInit {
    const request: RequestInit = {
        method: method,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${WebDeskAppStore.app.token || ''}`,
            'NfHotel-Link-Code': `${WebDeskAppStore.app.code || ''}`,
        },
    };
    if (body)
        request.body = JSON.stringify(body);
    return request;
}

export default async function webDeskFetch<T = { [prop: string]: any }>(url: string,
                                                                        request: RequestInit
): Promise<T> {
    const response = await fetch(url, request);
    const json = await response.json();
    if (!response.ok)
        throw new Error(json);
    return json;
}

export async function webDeskGet<T = { [prop: string]: any }>(endpoint: string | null = null,
                                                        query?: Record<string, any>,
                                                        awaitToken: boolean = true
): Promise<T> {
    if (awaitToken)
        await WebDeskAppStore.waitForToken();
    return await webDeskFetch(
        getWebDeskUrl(endpoint, {
            token: WebDeskAppStore.app.token || '',
            code: WebDeskAppStore.app.code || '',
            lang: WebDeskAppStore.app.lang,
            ...query
        }),
        getWebDeskRequest('GET')
    );
}

export async function webDeskPost<T = { [prop: string]: any }>(endpoint: string | null = null,
                                                         body?: Record<string, any>): Promise<T> {
    await WebDeskAppStore.waitForToken();
    body = merge({}, body, {lang: WebDeskAppStore.app.lang});
    return await webDeskFetch(
        getWebDeskUrl(endpoint),
        getWebDeskRequest('POST', body)
    );
}
